/**
 * 13 catégories d'engagements (parité BE-TAYE) avec icônes Lucide + couleurs.
 */
import { Landmark, CreditCard, Shield, Phone, Car, Cloud, Zap, Printer,
          Wrench, Building2, Briefcase, Newspaper, File } from "lucide-react";

export const CATEGORY_META = {
  pret:        { icon: Landmark,   color: "text-emerald-700", bg: "bg-emerald-100",  label: "Prêt bancaire",   emoji: "🏦" },
  credit:      { icon: CreditCard, color: "text-teal-700",     bg: "bg-teal-100",     label: "Crédit",          emoji: "💳" },
  assurance:   { icon: Shield,     color: "text-blue-700",     bg: "bg-blue-100",     label: "Assurance",       emoji: "🛡️" },
  telephonie:  { icon: Phone,      color: "text-purple-700",   bg: "bg-purple-100",   label: "Téléphonie",      emoji: "📱" },
  leasing:     { icon: Car,        color: "text-red-700",      bg: "bg-red-100",      label: "Leasing",         emoji: "🚗" },
  saas:        { icon: Cloud,      color: "text-cyan-700",     bg: "bg-cyan-100",     label: "SaaS / Logiciels",emoji: "☁️" },
  energie:     { icon: Zap,        color: "text-amber-700",    bg: "bg-amber-100",    label: "Énergie",         emoji: "💡" },
  materiel:    { icon: Printer,    color: "text-slate-700",    bg: "bg-slate-200",    label: "Matériel",        emoji: "🖨️" },
  maintenance: { icon: Wrench,     color: "text-orange-700",   bg: "bg-orange-100",   label: "Maintenance",     emoji: "🔧" },
  location:    { icon: Building2,  color: "text-indigo-700",   bg: "bg-indigo-100",   label: "Location",        emoji: "🏢" },
  services:    { icon: Briefcase,  color: "text-pink-700",     bg: "bg-pink-100",     label: "Services",        emoji: "💼" },
  abonnement:  { icon: Newspaper,  color: "text-violet-700",   bg: "bg-violet-100",   label: "Abonnement",      emoji: "📰" },
  autre:       { icon: File,       color: "text-slate-600",    bg: "bg-slate-100",    label: "Autre",           emoji: "📄" },
};

export const CATEGORIES = Object.entries(CATEGORY_META).map(([value, m]) => ({ value, label: m.label, emoji: m.emoji }));

export const getCategoryMeta = (cat) => CATEGORY_META[cat] || CATEGORY_META.autre;

export const fmtEur = (v) => (v == null) ? "-" :
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);

export const fmtEurPrecise = (v) => (v == null) ? "-" :
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(v);

export const fmtDate = (s) => {
  if (!s) return "-";
  try { return new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return s; }
};

export const fmtDateShort = (s) => {
  if (!s) return "-";
  try { return new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short" }); }
  catch { return s; }
};
